import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('contractor')
export class Contractor{
    @PrimaryGeneratedColumn('increment',{
        name:'contractor_id'
    })
    contractorId:number;

    @Column('varchar',{
        nullable:false,
        name:'contractor_name'
    })
    contractorName:string;

    @Column('varchar',{
        nullable:true,
        name:'contractor_Pro_Id'
    })
    contractorProId:string;

    @Column('varchar',{
        nullable:false,
        name:'contractor_Type'
    })
    contractorType:string;

    @Column('int',{
        nullable:false,
        name:'no_of_employees'
    })
    noOfEmployees:number;

    @Column({
        name:'from_date'
    })
    fromDate:Date;

    @Column({
        name:'to_date'
    })
    toDate:Date;

    @Column('varchar',{
        name:'contract_period'
    })
    contractPeriod:string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean | null;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}